import React from "react";
import "./ListToolbar.css";

export default function ListToolbar({
  value,
  onChange,
  onNew,
  disabledNew = false,
  searchPlaceholder = "Buscar...",
  newLabel = "Novo",
}) {
  return (
    <div className="cmd-toolbar">
      <input
        type="text"
        className="cmd-toolbar__search"
        placeholder={searchPlaceholder}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
      />

      {onNew && (
        <button
          type="button"
          className="cmd-toolbar__new-btn"
          onClick={onNew}
          disabled={disabledNew}
        >
          {newLabel}
        </button>
      )}
    </div>
  );
}